// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o5-c";
export var backButton = "_o5-4";
export var backIcon = "_o5-5";
export var chevronShortcut = "_o5-6";
export var container = "_o5-1";
export var editor = "_o5-8";
export var editorWrapper = "_o5-7";
export var prefix = "_o5-2";
export var searchIcon = "_o5-3";
export var suffix = "_o5-9";
export var suffixContent = "_o5-a";
export var suffixText = "_o5-b";
export var wrapper = "_o5-0";